import t from 'tcomb';
import Margin_Bottom_Style  from './style/Margin_Bottom_Style';
import Str_Schema  from './Str_Schema';
import Num_Schema  from './Num_Schema';
import UUID  from './UUID';

const Textbox_Component_Style = Margin_Bottom_Style;

const Textbox_Component_Schema = t.union([Str_Schema, Num_Schema]);

Textbox_Component_Schema.dispatch = (obj) => {
  return obj.type === 'string' ? Str_Schema : Num_Schema;
};

const Textbox_Component = t.struct({
  id: UUID,
  name: t.Str,
  style: Textbox_Component_Style,
  schema: Textbox_Component_Schema,
  is_multiline: t.maybe(t.Bool)
}, 'Textbox_Component');

Textbox_Component.prototype.to_form = function() {
  return {
    type: 'textbox',
    id: this.id,
    attrs: {
      style: this.style
    },
    schema: this.schema,
    is_multiline: this.is_multiline
  };
};

export default Textbox_Component;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Textbox_Component.js
 **/